// extracted by mini-css-extract-plugin
module.exports = {"PartnerLogo":"PartnerLogo_PartnerLogo__33Myz","PartnerLogo__image":"PartnerLogo_PartnerLogo__image___5R0Y"};